import { render, staticRenderFns } from "./ProductCollections.vue?vue&type=template&id=75fe2728"
import script from "./ProductCollections.vue?vue&type=script&lang=js"
export * from "./ProductCollections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports